import { apiHandlerWithError } from 'api/apiHandler';

export default async function getProjects() {
  return await apiHandlerWithError('projects');
}
